<template>
  <div class="olderBase">
    <el-row class="olderBase-a">
      <el-col>
        <img
          src="@/assets/beadhouse/juxing.png"
          style="vertical-align:middle"
        />
        <span style="vertical-align:middle;font-size:16px;margin-left:10px"
          >合同信息</span
        >
      </el-col>
    </el-row>
    <el-form
      :model="addForm"
      label-width="120px"
      :rules="addFormRules"
      ref="addForm"
    >
      <el-row>
        <el-col :span="8">
          <el-form-item label="合同编号" prop="contractNo">
            <el-input
              v-model="addForm.contractNo"
              maxlength="20"
              class="width80"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="合同类型" prop="contractType">
            <el-select
              v-model="addForm.contractType"
              placeholder="请选择"
              clearable
              class="width80"
            >
              <el-option
                label="初签"
                value="初签"
              ></el-option>
              <el-option
                label="续签"
                value="续签"
              ></el-option>
              <el-option
                label="补签"
                value="补签"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="签约日期" prop="signDay">
            <el-date-picker
              :clearable="false"
              v-model="addForm.signDay"
              type="date"
              class="width80"
              placeholder="请选择签约日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="老人姓名" prop="oldName">
            <el-autocomplete
              v-model.trim="addForm.oldName"
              auto-complete="off"
              clearable
              :readonly="oldmanId!=null"
              class="width80"
              placeholder="请选择老人"
              :fetch-suggestions="querySearchAsync"
              @select="handleOlderSelect"
            ></el-autocomplete>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="身份证号" prop="oldIdCard" ref="oldIdCard">
            <el-input
              v-model="chooseOld.oldIdCard"
              readonly
              class="width80"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话" prop="sex">
            <el-input
              v-model="chooseOld.oldPhone"
              readonly
              class="width80"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="合同起始时间" prop="contractStart">
            <el-date-picker
              :clearable="false"
              v-model="addForm.contractStart"
              type="date"
              class="width80"
              placeholder="请选择起始时间"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="合同结束时间" prop="contractEnd">
            <el-date-picker
              :clearable="false"
              v-model="addForm.contractEnd"
              type="date"
              class="width80"
              placeholder="请选择结束时间"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="费用标准" prop="expirationDay">
            <el-input
              v-model="addForm.expirationDay"
              class="width80"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="付款方式" prop="payType">
            <el-select
              v-model="addForm.payType"
              placeholder="请选择"
              clearable
              class="width80"
            >
            <el-option
              label="月付"
              value="2"
            ></el-option>
            <el-option
              label="季付"
              value="3"
            ></el-option>
            <el-option
              label="半年付"
              value="1"
            ></el-option>
            <el-option
              label="年付"
              value="0"
            ></el-option>
            <el-option
              label="试入住"
              value="4"
            ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="办理人" prop="creator">
            <el-input
              v-model="addForm.creator"
              class="width80"
          ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="部门" prop="groupName">
            <el-input
              v-model="addForm.groupName"
              class="width80"
          ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="介绍人" prop="introducer">
            <el-input
              v-model="addForm.introducer"
              class="width80"
          ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="addForm.remark"
              style="width:91%"
          ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-col class="marginten">
        <img
          src="@/assets/beadhouse/juxing.png"
          style="vertical-align:middle"
        />
        <span style="vertical-align:middle;font-size:16px;margin-left:10px"
          >担保人</span
        >
      </el-col>
      <el-row>
        <el-col :span="8">
          <el-form-item label="担保人姓名" prop="warrantor">
            <el-input
              v-model.trim="addForm.warrantor"
              maxlength="15"
              class="width80"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="担保人身份证" prop="wrntIdcard">
            <el-input
              v-model.trim="addForm.wrntIdcard"
              maxlength="15"
              class="width80"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="与老人关系" prop="wrntShip">
            <el-select
              v-model="addForm.wrntShip"
              placeholder="请选择"
              clearable
              class="width80"
            >
              <el-option
                label="子女"
                value="0"
              ></el-option>
              <el-option
                label="兄弟姐妹"
                value="1"
              ></el-option>
              <el-option
                label="旁系亲属"
                value="2"
              ></el-option>
              <el-option
                label="朋友"
                value="3"
              ></el-option>
              <el-option
                label="其他"
                value="4"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="担保人电话" prop="wrntPhoneOne">
            <el-input v-model="addForm.wrntPhoneOne" class="width80"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="担保人电话2" prop="wrntPhoneTwo">
            <el-input v-model="addForm.wrntPhoneTwo" class="width80"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="担保人电话3" prop="wrntPhoneThree">
            <el-input v-model="addForm.wrntPhoneThree" class="width80"></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="担保人住址" prop="wrntAddress">
            <el-input v-model="addForm.wrntAddress" style="width:94%"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-col class="marginten">
        <img
          src="@/assets/beadhouse/juxing.png"
          style="vertical-align:middle"
        />
        <span style="vertical-align:middle;font-size:16px;margin-left:10px"
          >合同照片</span
        >
      </el-col>
      <el-row style="padding-left:40px"> 
        <el-upload
            class="avatar-uploader"
            action="string"
            v-model="addForm.postPic"
            accept="image/png, image/jpeg"
            list-type="picture-card"
            :file-list="fileList"
            :http-request="uploadSectionFile"
            :before-upload="uploadSuccess"
            :before-remove="handleRemove"
            :on-success="successup"
            :limit="9"
            ref="imagePic"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
      </el-row>
    </el-form>
    <div slot="footer" class="footer" align="center">
      <el-button type="warning" plain @click="back">返回</el-button>
      <el-button type="primary" plain @click="submitData" :loading="addLoading">完成</el-button>
    </div>

  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import util from "@/utils/util.js";
export default {
  name: "ContractAdd",
  data() {
    return {
      oldmanId: "", //老人的id,用于请求数据获取老人的百度经纬度
      addLoading:false,
      //form表单的数据源
      chooseOld:[],
      fileList: [],
      fileDataList:[],
      contractBean:{},
      addForm: {
        signDay: util.formatDate.format(new Date(), "yyyy-MM-dd"),
        oldName:"",
      },
      //form表单的正则验证
      addFormRules: {
        contractNo: [{ required: true, message: "请输入合同编号", trigger: "blur" }],
        oldName: [
          { required: true, message: "请输入姓名", trigger: ['blur', 'change']},
        ],
        signDay: [{ required: true, message: "请选择签约日期", trigger: "blur" },],
        warrantor: [{ required: true, message: "请填写担保人信息", trigger: "blur" },],
        creator: [{ required: true, message: "请填写办理人信息", trigger: "blur" },],
        contractStart: [{ required: true, message: "请选择合同起始日期", trigger: "blur" },],
        contractEnd: [{ required: true, message: "请选择合同结束日期", trigger: "blur" },],
      },
    };
  },
  methods: {
    /* 
    根据模糊查询老人返回老人id
  */
  handleOlderSelect(item) {
    this.addForm.oldmanId = item.oldmanId;
    this.chooseOld = item;
  },
  /* 
    模糊查询老人
  */
  querySearchAsync(queryString, cb) {
      let param = {
        oldName: queryString
      };
      this.$postJson("omc/Oldman/quickShowAllOldMan", param).then((res) => {
        var list = [{}];
        if (res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
          setTimeout(() => {
            this.addForm.oldName = "";
          }, 1000);
        }
      });
    },

    //点击下一步提交数据
    submitData() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          let params = new Object();
          params = Object.assign({}, this.addForm);
          console.log(this.fileDataList)
          params.contractPic = this.fileDataList.join('%%');
          let url = "";
          if (this.contractId == null) {
            url = "fmc/contract/add";
          } else {
            url = "fmc/contract/edit";
          }
          console.log(url);

          this.addLoading = true;
          this.$postJson(url, params)
            .then(res => {
              this.addLoading = false;
              if (res.status || res.code == 200) {
                this.$message({ message: res.message, type: "success" });
                this.back();
              } else {
                this.$message({
                  message: res.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.$message({
                message: error,
                type: "error"
              });
            });
        } else {
          this.$message({ message: "请检查红色项是否填写正确", type: "error" });
        }
      });
    },
    //上传图片
    uploadSectionFile(param) {
      var fileObj = param.file;
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "picture");
        form.append("bucketName", "cmny-oss");
        this.$postFormData("dmc/file/uploadFile", form).then(res => {
          this.fileDataList.push(res.result); //添加图片的url
          if (res.code == 200) {
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      }
    },
    successup(response, file, fileList) {
      this.$refs["postPic"].clearValidate();
    },
    uploadSuccess(file) {
      const isJPG = file.type == "image/jpeg" || file.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 9;
      const limit = this.fileDataList.length <= 9;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或PGN 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 9MB!");
      }
      if (!limit) {
        this.$message.error("上传图片最多只能10张");
      }
      return isJPG && isLt2M && limit;
    },

    //删除图片
    handleRemove(file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        if (file.uid == fileList[i].uid) {
          this.fileDataList.splice(i, 1);
        }
      }
    },
    //回退的方法
    popstate() {
      history.pushState(null, null, document.URL);
    },
    /*
      在该页面防止浏览器点击后退按钮
    */
    fobiddenBack() {
      //防止页面后退
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.popstate, true);
      window.addEventListener("keydown", this.keydown, true);
      window.onbeforeunload = function() {
        window.event.returnValue = "阻止";
      };
    },
    //返回
    back() {
      bus.$emit("refreshContract",{});
      bus.$emit('close_current_tags');
    },
    /*
      form表单数据回显
    */
    selectContract(contractId) {
      this.$postJson("fmc/contract/showById/"+contractId).then(res => {
        console.log(res);
        if(res.result.contractPic.length>5){
          this.fileDataList = res.result.contractPic.split("%%");
          this.fileList = [];
          this.fileDataList.forEach((item) =>{
            this.fileList.push({
              url:item
            })
          })
        }
        this.contractBean = res.result;
        this.queryOld(res.result.oldmanId);
      });
    },
    queryOld(oldmanId){
      let param = {
        oldmanId: oldmanId
      };
      this.$postJson("omc/Oldman/showOldManSupAll", param).then(res =>{
        this.addForm = Object.assign({}, this.contractBean);
        this.addForm['oldName'] = res.result.list[0].oldName;
        this.addForm['payType'] = ''+this.addForm.payType;
        this.chooseOld = res.result.list[0];
      })
    }
  },
  created() {
  },
  mounted() {
    this.contractId = this.$route.query.contractId;
    if (this.contractId != null) {
      this.selectContract(this.contractId);
    }
    this.fobiddenBack();
  },
  destroyed() {
    window.removeEventListener("popstate", this.popstate, true);
    window.removeEventListener("keydown", this.keydown, true);
  }
};
</script>
<style lang="scss" scoped>
.olderBase {
    background: #fff;
    .olderBase-a {
    height: 60px;
    line-height: 60px;
  }
  .height40 {
    height: 40px;
    line-height: 40px;
  }
  .width80 {
    width: 80%;
  }
  .marginten{
    margin-top: 2px;
    margin-bottom: 20px;
  }
  .footer {
    padding: 30px 0;
    background: #fff;
  }
  .oldmanmap {
    margin: 20px 5px;
    border: 1px solid rgb(228, 222, 222);
    .map {
      width: 100%;
      height: 400px;
    }
  }
  ::deep .crcDisOther {
    position: relative;
  }
  ::deep .otherAddCheck .el-input__inner {
    position: absolute;
    left: -80px;
    top: -20px;
    width: 256px;
  }

  ::deep .crcDisOther .el-form-item__error {
    width: 120px !important;
    position: absolute;
    top: 45px;
    left: -80px;
  }
  //地图插件·
  ::deep .BMap_stdMpCtrl {
    top: 50px !important;
  }
  ::deep .citylist_popup_main {
    margin-left: 45px;
  }
  //  ::deep深度作用选择符
  ::deep .el-dialog__header {
    text-align: left;
    background: rgb(238, 231, 231);
    border-bottom: 2px solid rgb(211, 207, 207);
  }
  ::deep .el-dialog__body {
    padding: 10px !important;
  }
  ::deep .el-dialog-map {
    width: 120%;
    margin-top:-5%;
    .el-input__inner {
      width: 50%;
    }
  }
}
</style>
